import React, { useState, useContext, useRef, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { User, LogOut, Settings, Search } from 'lucide-react'
import { AuthContext } from '../../auth/AuthContext'
import { ThemeToggle } from '../ThemeToggle'
import { MobileNav } from './MobileNav'

export function Header() {
  const { user, logout } = useContext(AuthContext)
  const navigate = useNavigate()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)

  const handleLogout = () => {
    logout()
    localStorage.removeItem('token')
    navigate('/login')
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }
    function handleKeyDown(event) {
      if (event.key === 'Escape') {
        setDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="w-full flex h-16 items-center px-4 sm:px-6 lg:px-8">
        <NavLink to="/" className="flex items-center">
          <span className="font-bold text-lg">StockSights</span>
        </NavLink>

        <div className="flex items-center ml-auto gap-2">
          {user && (
            <div className="lg:hidden">
              <MobileNav user={user} onLogout={handleLogout} />
            </div>
          )}

          {user && (
            <button
              onClick={() => window.__openCommandPalette?.()}
              className="inline-flex items-center justify-center rounded-md min-w-11 min-h-11 w-11 h-11 border border-input bg-background hover:bg-accent hover:text-accent-foreground"
              aria-label="Ouvrir la palette de commandes"
            >
              <Search className="h-4 w-4" />
            </button>
          )}

          <ThemeToggle />
        </div>

        <div className="flex items-center pl-2">
          {user ? (
            <div className="relative hidden md:block" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="inline-flex items-center justify-center rounded-full min-w-11 min-h-11 w-11 h-11 bg-primary text-primary-foreground"
                aria-label="Profil utilisateur"
              >
                <User className="h-4 w-4" />
              </button>

              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 rounded-md border bg-popover text-popover-foreground shadow-lg z-50">
                  <div className="p-2 space-y-1" role="menu">
                    <button
                      className="w-full flex items-center rounded-sm px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground"
                      onClick={() => setDropdownOpen(false)}
                      role="menuitem"
                    >
                      <Settings className="mr-2 h-4 w-4" />
                      Modifier le profil
                    </button>
                    <button
                      className="w-full flex items-center rounded-sm px-2 py-1.5 text-sm text-destructive hover:bg-destructive/10"
                      onClick={handleLogout}
                      role="menuitem"
                    >
                      <LogOut className="mr-2 h-4 w-4" />
                      Se déconnecter
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <NavLink
              to="/login"
              className="inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90"
            >
              Se connecter
            </NavLink>
          )}
        </div>
      </div>
    </header>
  )
}
